import { Eye, EyeOff } from "lucide-react";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import PwResetUser from "../../Components/PwResetUser";
import CustomButton from "../../Components/Ui/CustomButton";
import { useAuth } from "../../Store/auth-context";

const LoginPage = () => {
  const [enteredUsername, setEnteredUsername] = useState("");
  const [enteredPassword, setEnteredPassword] = useState("");
  const [showPwReset, setShowPwReset] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const { login } = useAuth();
  let navigate = useNavigate();

  const handleLogin = async (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
    try {
      const _ = await login(enteredUsername, enteredPassword);
      if (_) {
        return navigate("/");
      } else {
        toast.error("Bitte gültigen Nutzernamen & Passwort eingegeben.");
      }
    } catch (error) {
      alert("An error occurred. Please try again.");
    }
  };

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const closePwReset = () => {
    setShowPwReset(false);
  };

  const passwordChangeHandler = (e: string) => {
    setEnteredPassword(e);
  };

  const usernameChangeHandler = (e: string) => {
    setEnteredUsername(e);
  };

  return (
    <div className="font-sans mt-10 p-0 flex items-center justify-center h-auto select-none">
      <ToastContainer />

      {!showPwReset ? (
        <div className="bg-gray-200 rounded-lg shadow p-5 w-full max-w-xs sm:max-w-md md:max-w-lg lg:max-w-xl text-center">
          <div className="text-[#003C78] text-lg sm:text-xl md:text-2xl mb-5">
            Anmelden
          </div>
          <form>
            <div className="mb-5 w-full">
              <label
                htmlFor="username"
                className="block mb-2 text-gray-500 text-sm sm:text-base"
              >
                Nutzername:
              </label>
              <input
                type="text"
                id="username"
                name="username"
                required
                onChange={(e) => usernameChangeHandler(e.target.value)}
                className="w-full p-2 sm:p-2.5 border border-gray-500 rounded mb-2.5"
              />
            </div>
            <div className="mb-5 w-full">
              <label
                htmlFor="password"
                className="block mb-2 text-gray-500 text-sm sm:text-base"
              >
                Passwort:
              </label>
              <div className="flex items-center">
                <input
                  type={showPassword ? "text" : "password"}
                  id="password"
                  name="password"
                  required
                  onChange={(e) => passwordChangeHandler(e.target.value)}
                  className="w-full p-2 sm:p-2.5 border border-gray-500 rounded"
                />
                <button
                  type="button"
                  onClick={togglePasswordVisibility}
                  className="bg-gray-300 p-2 sm:p-2.5 rounded-r-lg"
                >
                  {showPassword ? <EyeOff size={20} /> : <Eye size={20} />}
                </button>
              </div>
            </div>
            <div className="">
              <div className="flex justify-center">
                <CustomButton
                  theme="navy"
                  onClick={(event) => handleLogin(event)}
                  className="bg-blue-500 text-white p-2 sm:p-2.5 rounded cursor-pointer text-sm sm:text-lg hover:bg-blue-700"
                >
                  anmelden
                </CustomButton>
              </div>
              <div className="mt-5">
                <button
                  onClick={() => setShowPwReset(true)}
                  className="text-orange-600 text-xs sm:text-sm cursor-pointer hover:text-red-600 focus:outline-none"
                >
                  Passwort vergessen?
                </button>
              </div>
            </div>
          </form>

          <div className="mt-5 text-xs ">Version 1.2.5.0</div>
        </div>
      ) : (
        <PwResetUser closeModal={() => closePwReset()} />
      )}
    </div>
  );
};

export default LoginPage;
